import React from 'react'
import { useDispatch } from 'react-redux';
import { setAmount } from '../../Redux/shoppingCartReducer';
import { useTranslation } from '../../hooks/useTranslation';

function QuantityButtons({ addItemToCart, removeItemFromCart, itemsCount, product }) {
    const { t } = useTranslation();

    const dispatch = useDispatch();
    return (
        <div>
            <button aria-label={`${t("Quantity")} ${itemsCount} ${"add"}`} onClick={() => addItemToCart()}>+</button>
            <input type="number" className="qty-input" value={Number(itemsCount).toString()} onChange={e => dispatch(setAmount({ selectedProduct: product, qty: e.target.value }))} />
            <button aria-label={`${t("Quantity")} ${itemsCount} ${"remove"}`} onClick={() => removeItemFromCart()}>-</button>
        </div>
    )
}

export default QuantityButtons